import React from "react";

export default function EbookDownloads() {
	return (
		<>
			<h2 className="hd-center">Beratungsprodukte</h2>
			<div className="downloads_books">
				<div className="download_book">
					<div className="book-image">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2024/08/Das-Orga-Check-Konzept-der-Feingeist-Beratung.pdf">
							<img
								className="ebook-img"
								src="https://feingeist-beratung.de/wp-content/uploads/2024/08/Das-Orga-Check-Konzept-der-Feingeist-Beratung.png"
							/>
						</a>
					</div>
					<div className="ebook-desc">
						<h3>Orga Check-Konzept</h3>
						<p>Orga Check-Konzept der Feingeist GmbH</p>
					</div>
				</div>
				<div className="download_book">
					<div className="book-image">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2024/04/Der-Digitality-Check-der-Feingeist-GmbH-Edition-Hausverwaltung.pdf">
							<img
								className="ebook-img"
								src="https://feingeist-beratung.de/wp-content/uploads/2024/04/Der-Digitality-Check-der-Feingeist-GmbH-Edition-Hausverwaltung-300x169.png"
							/>
						</a>
					</div>

					<div className="ebook-desc">
						<h3>Digitality Check</h3>
						<p>Digitality Check der Feingeist GmbH - Edition Hausverwaltung</p>
					</div>
				</div>
				<div className="download_book">
					<div className="book-image">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2023/12/der_messdienst_check_der_feingeist_beratung.pdf">
							<img
								className="ebook-img"
								src="https://feingeist-beratung.de/wp-content/uploads/2023/12/der_messdienst_check_der_feingeist_beratung-cover-300x169.png"
							/>
						</a>
					</div>

					<div className="ebook-desc">
						<h3>Messdienst Check</h3>
						<p>Messdienst Check der Feingeist Beratung</p>
					</div>
				</div>
				<div className="download_book">
					<div className="book-image">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2023/12/der_business_check_der_feingeist_gmbh_edition_hausverwaltung.pdf">
							<img
								className="ebook-img"
								src="https://feingeist-beratung.de/wp-content/uploads/2023/12/der_business_check_der_feingeist_gmbh_edition_hausverwaltung-cover-300x169.png"
							/>
						</a>
					</div>

					<div className="ebook-desc">
						<h3>Business Check</h3>
						<p>Business Check der Feingeist GmbH - Edition Hausverwaltung</p>
					</div>
				</div>
				<div className="download_book">
					<div className="book-image">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2023/12/das_kennzahlen_cockpit_der_feingeist_gmbh.pdf">
							<img
								className="ebook-img"
								src="https://feingeist-beratung.de/wp-content/uploads/2023/12/das_kennzahlen_cockpit_der_feingeist_gmbh-cover-300x169.png"
							/>
						</a>
					</div>

					<div className="ebook-desc">
						<h3>Kennzahlen Cockpit</h3>
						<p>Business Check der Feingeist GmbH - Edition Hausverwaltung</p>
					</div>
				</div>
				<div className="download_book">
					<div className="book-image">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2024/04/Portfolio-der-Feingeist-Beratung.pdf">
							<img
								className="ebook-img"
								src="https://feingeist-beratung.de/wp-content/uploads/2024/04/Portfolio-der-Feingeist-Beratung-300x168.png"
							/>
						</a>
					</div>

					<div className="ebook-desc">
						<h3>Portfolio</h3>
						<p>Portfolio der Feingeist Beratung</p>
					</div>
				</div>
				<div className="download_book">
					<div className="book-image">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2023/12/interim-management_der_feingeist_beratung.pdf">
							<img
								className="ebook-img"
								src="https://feingeist-beratung.de/wp-content/uploads/2023/12/interim-management_der_feingeist_beratung-cover-208x300.png"
							/>
						</a>
					</div>

					<div className="ebook-desc">
						<h3>Interim-Management</h3>
						<p> Interim-Management der Feingeist Beratung</p>
					</div>
				</div>
				<div className="download_book">
					<div className="book-image">
						<a href="http://feingeist-beratung.de/wp-content/uploads/2024/12/Scale-up-der-Feingeist-GmbH.pdf">
							<img
								className="ebook-img"
								src="https://feingeist-beratung.de/wp-content/uploads/2024/12/Scale-up-der-Feingeist-GmbH-pdf.jpg"
							/>
						</a>
					</div>

					<div className="ebook-desc">
						<h3>Scale-up Programm</h3>
						<p> Scale-up Programm der Feingeist Beratung</p>
					</div>
				</div>
			</div>
		</>
	);
}
